/// <reference path="../../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../components.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class FinishContractModalController {
        public static $inject: string[] = [
            '$filter',
            '$mdMedia',
            '$mdDialog',
            '$mobilityCompanyAuthentication',
            '$dealerwareNotification',
            '$dealerwareInternationalizationDateFormats',
            '$dealerwareInternationalizationData',
            'MicroFrontendOrigin'
        ];

        private isMetric: boolean;
        public contract: any;
        public warnings: any;
        public collisions: any;
        public labels: {};

        constructor(public $filter: any,
                    public $mdMedia: any,
                    public $mdDialog: any,
                    public $mobilityCompanyAuthentication: any,
                    private $dealerwareNotification: any,
                    public $dealerwareInternationalizationDateFormats: any,
                    public $dealerwareInternationalizationData: any) {
                      this.isMetric = $mobilityCompanyAuthentication.location.settings.metric;
                      this.getLabels('contracts');
                    }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                        _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                    },
                    function(error: any) {
                        _self.$dealerwareNotification.apiError(error);
                    }
                );
        }

        public get useFullScreen() {
            return (this.$mdMedia('xs') || this.$mdMedia('sm'));
        }

        public open() {
            var that = this;

            function openFinishModal() {
                that.$mdDialog.show({
                    controller: FinishDialogController,
                    locals: { contract: that.contract, isMetric: that.isMetric },
                    templateUrl: '/components/contract/details/finish/finish_contract_modal_directive.html',
                    parent: angular.element(document.body),
                    multiple: true,
                    clickOutsideToClose: false,
                    fullscreen: that.useFullScreen
                });
            }

            if (this.warnings.length > 0 || this.collisions.length > 0) {
                this.$mdDialog.show({
                    controller: NoticesDialogController,
                    locals: { contract: this.contract, warnings: this.warnings, collisions: this.collisions },
                    templateUrl: '/components/contract/details/finish/finish_contract_notices_modal_directive.html',
                    parent: angular.element(document.body),
                    multiple: true,
                    clickOutsideToClose: false,
                    fullscreen: this.useFullScreen
                })
            } else {
                openFinishModal();
            }

            function NoticesDialogController($scope: any,
                                             $rootScope: any,
                                             $mdDialog: any,
                                             DealerwareVehicleModel: any,
                                             $dealerwareLoading: any,
                                             $dealerwareNotification: any,
                                             contract: any,
                                             warnings: any,
                                             collisions: any) {
                $scope.contract = contract;
                $scope.warnings = warnings;
                $scope.collisions = collisions;

                $scope.hasWarnings = function() {
                    return $scope.warnings && $scope.warnings.length > 0;
                }

                $scope.hasCollisions = function() {
                    return $scope.collisions && $scope.collisions.length > 0;
                }

                function getTitle() {
                    if ($scope.hasWarnings()) {
                        if ($scope.hasCollisions()) {
                            return that.labels.messages.collisionsAndWarningsTitle;
                        }
                        return that.labels.messages.svcWarningsTitle;
                    } else if ($scope.hasCollisions()) {
                        return that.labels.messages.collisionsTitle;
                    }
                    openFinishModal();
                    return '';
                }
                $scope.title = getTitle();

                function collisionsText() {
                    return $scope.hasWarnings() ? that.labels.messages.collisionsAndWarnings : that.labels.messages.collisions;
                }
                $scope.collisionsText = collisionsText();

                $scope.svcWarningsHeader = that.labels.messages.svcWarningsHeader;
                $scope.svcWarning = that.labels.messages.svcWarning;
                $scope.svcWarningsFooter = that.labels.messages.svcWarningsFooter;

                $scope.agree = that.labels.messages.agree;

                $scope.openFinishModal = function() {
                    $mdDialog.hide();
                    openFinishModal();
                };
            }

            function FinishDialogController($scope: any,
                                            $rootScope: any,
                                            $mdDialog: any,
                                            DataUtils: any,
                                            $mobilityCompanyAuthentication: any,
                                            DealerwareVehicleModel: any,
                                            $dealerwareLoading: any,
                                            $dealerwareNotification: any,
                                            contract: any,
                                            isMetric: boolean,
                                            RoundValues: any,
                                            $dealerwareInternationalizationDateFormats: any,
                                            MicroFrontendOrigin: string) {
                var location = $mobilityCompanyAuthentication.location,
                    car = contract.contractDetails.data.car;

                $scope.internationalization = $dealerwareInternationalizationDateFormats.datePickerFormat();
                $scope.contract = contract;
                $scope.dropoffDate = moment().toDate();
                $scope.dropoffTime = defaultDropoffTime();
                $scope.originalFuel = undefined;
                $scope.fuel = undefined;
                $scope.hasFuelChanged = false;

                if (location && car && location.has_ccs && car.connected) {
                    var loader = $dealerwareLoading.show('Please Wait...');
                    DealerwareVehicleModel.telematicsLastEvent({
                        promise: true,
                        params: {
                            id: car.id
                        }
                    }).then(
                        (lastEvent: any) => {
                            var lastScan = lastEvent.data
                            var mileage = calculateMileage(lastScan.odometer.value, lastScan.odometer.unit, isMetric)
                            var fuel = lastScan.fuel.value
                            var eventReceivedAt = lastEvent.data.event_received_at;

                            $scope.mileage = parseInt(mileage, 10);
                            $scope.originalFuel = originalFuelPercentage(fuel, car.fuel_capacity);
                            $scope.fuel = lastReportedFuel(car, fuel);
                            $scope.carLastUpdated = DataUtils.getInstance().formatTimestampSimple(
                                eventReceivedAt,
                                location.time_zone_name
                            );
                            loader.close();
                        },
                        () => {
                            $scope.manualEntryMessage = that.labels.messages.telemetry_manual_entry;
                            $scope.emptyMileageMessage = that.labels.messages.empty_mileage;
                            $scope.emptyFuelMessage = that.labels.messages.empty_fuel;
                            loader.close();
                        }
                    )
                } else {
                    $scope.emptyMileageMessage = that.labels.messages.empty_mileage;
                    $scope.emptyFuelMessage = that.labels.messages.empty_fuel;
                }

                $scope.times = $dealerwareInternationalizationDateFormats.getAvailablesTimesFormat();

                $scope.fuelLevels = [
                    { display: that.labels.messages.full, value: 100 },
                    { display: '15/16', value: 93.75 },
                    { display: '7/8', value: 87.5 },
                    { display: '13/16', value: 81.25 },
                    { display: '3/4', value: 75 },
                    { display: '11/16', value: 68.75 },
                    { display: '5/8', value: 62.5 },
                    { display: '9/16', value: 56.25 },
                    { display: '1/2', value: 50 },
                    { display: '7/16', value: 43.75 },
                    { display: '3/8', value: 37.5 },
                    { display: '5/16', value: 31.25 },
                    { display: '1/4', value: 25 },
                    { display: '3/16', value: 18.75 },
                    { display: '1/8', value: 12.5 },
                    { display: '1/16', value: 6.25 },
                    { display: that.labels.messages.empty, value: 0 }
                ];

                function defaultDropoffTime() {
                    var now = moment().startOf('minute');

                    if (now.minute() < 30) {
                        now.add(30 - now.minute(), 'minutes');
                    } else {
                        now.add(1, 'hour');
                        now.subtract(now.minute(), 'minutes');
                    }

                    return now.format('HH:mm:ss');
                }

                function calculateMileage(mileage: number, unit: string, isMetric: boolean) {
                    if (unit == "km" && isMetric) return mileage;
                    if (unit == "mi" && !isMetric) return mileage;

                    let miles_to_km = 1.60934;
                    let km_to_miles = 0.621371;
                    let converted_mileage = 0;

                    if (unit == "mi") {
                        converted_mileage = mileage * miles_to_km
                    } else if (unit == "km") {
                        converted_mileage = mileage * km_to_miles
                    }

                    return converted_mileage;
                }

                function setDataFromCarModel(car: any) {
                    var mileage = isMetric ? car.mileage_in_km : car.mileage;

                    $scope.mileage = parseInt(mileage, 10);
                    $scope.fuel = lastReportedFuel(car);
                    $scope.carLastUpdated = DataUtils.getInstance().formatTimestampSimple(
                        car.updated_at,
                        location.time_zone_name
                    );

                    if (!car.connected) {
                        $scope.originalFuel = originalFuelPercentage(car.fuel, car.fuel_capacity);
                    }
                };

                function lastReportedFuel(car: any, fuel?: number) {
                    const reportedFuel = fuel || car.fuel;

                    return RoundValues.fuelPercentage(reportedFuel, car.fuel_capacity, car.connected);
                }

                function originalFuelPercentage(fuel: number, capacity: number) {
                    return parseFloat((fuel / capacity * 100).toFixed(2));
                }

                $scope.cancel = function() {
                    $mdDialog.hide();
                };

                $scope.changeFuel = function() {
                    $scope.hasFuelChanged = true;
                }

                $scope.confirmFinishContract = function() {
                    var fuelLabel = $scope.fuelLevels.find((level) => { return level.value == $scope.fuel }).display,
                        message = `
                            ${that.labels.messages.confirm_vehicle_data}:<br/><br/>
                            <strong>${that.labels.messages.mileage}:</strong> ${$scope.mileage}<br/>
                            <strong>${that.labels.messages.fuel}:</strong> ${fuelLabel}`;

                    var confirm = that.$mdDialog.confirm()
                        .htmlContent(message)
                        .ariaLabel(message)
                        .multiple(true)
                        .ok('Confirm')
                        .cancel('Cancel');

                    that.$mdDialog.show(confirm)
                        .then(()=> {
                            $scope.finishContract()
                        })
                }

                $scope.finishContract = function() {
                    var loader = $dealerwareLoading.show('Finishing...');
                    var fuel = !$scope.hasFuelChanged && $scope.originalFuel
                        ? $scope.originalFuel
                        : $scope.fuel;
                    $scope.contract.contractDetails.$finish({
                        promise: true,
                        params: {
                            location_id: $scope.contract.locationId,
                            actual_dropoff_date: moment($scope.dropoffDate).format('YYYY-MM-DD'),
                            actual_dropoff_time: $scope.dropoffTime,
                            fuel_level: fuel,
                            ending_mileage: $scope.mileage
                        }
                    }).then(
                        () => {
                            $scope.contract.loadContractDetails().finally(() => {
                                const locationId = $scope.contract.locationId;
                                const contractId = $scope.contract.contractId;
                                const billingPageHash = `/${encodeURIComponent(locationId)}/contracts/details/${encodeURIComponent(contractId)}/billing`;
                                window.parent.postMessage({
                                    type: 'routing',
                                    hash: billingPageHash,
                                }, MicroFrontendOrigin);
                                loader.close();
                                $mdDialog.hide();
                            })
                        },
                        (response: any) => {
                            loader.close();
                            $dealerwareNotification.apiError(response);
                        }
                    );
                }
            }
        }
    }

    getDealerwareWebComponentsModule().controller('FinishContractModalController', FinishContractModalController);


    export class FinishContractModalDirective implements ng.IDirective {

        public restrict         : string    =   'A';
        public controller       : any       =   'FinishContractModalController';
        public controllerAs     : string    =   'finishContractModalController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   { contract: '=', warnings: '=', collisions: '=' };
        public transclude       : boolean   =   false;
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            elem    :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
            elem.bind('click', function() {
                    ctrls.open();
                }
            );
        }
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareFinishContractModal",() => new FinishContractModalDirective());
}
